var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-end my-3",staticStyle:{"float":"right","font-size":"8pt"}},[_c('span',[_vm._v("Versão: "+_vm._s(_vm.version))])])}
var staticRenderFns = []

export { render, staticRenderFns }